import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';

export default function QuiSommesNous() {
  return (
    <div>
      <Navigation />
      <Banner src='./img/stage-05.webp' classType='banner__image--center' />

      <div className='association  u-margin-bottom-big'>
        <h2 className=' heading-section u-center-text u-margin-bottom-big association__title'>
          L&apos;association
        </h2>
        <div className='association__container common-text'>
          <div className='association__text'>
            <div className='association__text--1'>
              Yoga Taranga est une association de Yoga située dans la Manche.
            </div>
            <div className='association__text--2 '>
              Yoga Taranga (= vague en Sanskrit) vous propose de découvrir les bienfaits
              qu&apos;offre cette science millénaire:
            </div>
            <ul className='association__text--3'>
              <li className='association__text--31'>Réduction du stress</li>
              <li className='association__text--32'>Relaxation</li>
              <li className='association__text--33'>Regain de vitalité</li>
              <li className='association__text--34'>
                Développement de la souplesse et de la concentration.
              </li>
            </ul>
            <div className='association__text--4'>
              Nous proposons des cours hebdomadaires dans la Manche (Saint -Lô) et des stages dans
              l'Orne.
            </div>
          </div>
          <div className='association__img'>
            <img src='./img/stage-07.webp' alt='' />
          </div>
        </div>
      </div>

      <div className='intervenants u-margin-bottom-big'>
        <h2 className=' heading-section u-margin-bottom-big  u-center-text intervenants__title'>
          Nos intervenants
        </h2>
        <div className='intervenants__container'>
          <div className='intervenants__img'>{/* <img src='./img/stage-06.webp' alt='' /> */}</div>
          <div className='intervenants__text'>
            <h3 className='intervenants__subtitle'>Antoine</h3>
            <p className='intervenants__text--1'>Fondateur de l&apos;association Yoga Taranga</p>
            <div className='presentation__icon--line'>
              <img src='./icons/line-1.svg' alt='icone dune ligne de separation' />
            </div>
            <p className='intervenants__text--2'>
              Enseignant certifié à l'enseignement du Yoga, Antoine pratique le yoga et la
              méditation depuis 13 ans et anime des cours de yoga depuis 6 ans
            </p>
            <div className='presentation__icon--line'>
              <img src='./icons/line-1.svg' alt='icone dune ligne de separation' />
            </div>

            <p className='intervenants__text--4'>
              Il a été initié en Inde au Chandra yoga auprès du Siddha Tamoul Sivayogi Sivarajan. Le
              chandra yoga appartient à la tradition des Siddhas dont les enseignements ne prêchent
              aucune doctrine, mais suggèrent une direction pour actualiser une perception directe,
              intuitive, personnelle et profonde de la réalité. Une des spécificités des Siddhas,
              parmi l&apos;ensemble des spiritualités de l&apos;Inde, est de donner une importance
              capitale au corps. Le corps est à l&apos;image du microcosme et du macrocosme, de
              l&apos;homme et de l&apos;univers. C&apos;est un temple, une frontière permettant
              d&apos;actualiser la transcendance.
            </p>
          </div>
        </div>
      </div>
      <div className='intervenants u-margin-bottom-big'>
        <h2 className=' heading-section u-margin-bottom-big  u-center-text intervenants__title'>
          Notre partenaire: Arkanhom et corps conscient
        </h2>
        <div className='intervenants__container'>
          <div className='intervenants__img--arka'>
            {/* <img src='./img/stage-06.webp' alt='' /> */}
          </div>
          <div className='intervenants__text'>
            <p className='intervenants__text--1'>
              ArkanHom, un espace d&apos;échanges et un lieu dédié au développement de la conscience
              à travers l&apos;exploration du corps conscient.
              <br />
              Le concept de « corps conscient » fait référence à un état de prise de conscience
              approfondie de son propre corps et de ses sensations.
              <br />
              D&apos;instant en instant, nous sommes toujours en conversation avec le monde, « nous
              » étant composé de notre esprit pensant – le mental – et de notre moi sensible. Nous
              accédons ainsi à des informations et des expériences tout au long de la journée. Notre
              esprit pensant conceptualise les sensations reçues par le biais d&apos;une narration
              incessante, agissant la plupart du temps comme un censeur ; ce bavardage mental ne
              nous quitte que rarement. Nous sommes ainsi enfermés dans une vision étroite et
              limitée de la vie.
              <br />
              Les méthodes que proposent l&apos;association ArkanHom ont pour objet de nous éloigner
              de cette domination mentale qui nous coupe de la vie « vivante » pour nous permettre
              d&apos;élargir notre sensibilité et ainsi habiter notre corps et retrouver le
              caractère sacré de l&apos;espace corporel.
              <br />
              La conception d&apos;Arkanhom du « corps conscient » est une approche holistique qui
              implique une attention soutenue et une sensibilité aux perceptions corporelles et aux
              processus internes du corps. Cela aide à maintenir un équilibre entre le mental et le
              physique, favorise le bien-être et une meilleure gestion du stress.
              <br /> Retrouver les stages et retraites proposées par Arknhom{' '}
              <a href='https://www.arkanhom.fr/)'>ici</a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
